export default {
  name: 'emergencyDrill',
  miniSave: false,
  uploadFunction: ({ requestFunction, data, saveId }) => {
    const now = new Date().toISOString().slice(0, 19).replace('T', ' ')
    const { reminderDate, ...rest } = data
    const uploadData = {
      ...rest,
      datestarted: data.datestarted || now,
      datefinished: data.datefinished || now,
      ...(reminderDate ? { reminderDate } : {}),
    }
    return requestFunction.methodRequest(
      '/crewconfig/meeting/drill',
      'PUT',
      uploadData
    )
  },
  restoreSave: (ctx) => {
    const data = ctx.saveObj.data
    ctx.router.push({
      name: `crews-crewid-emergency-drill-new`,
      params: { crewid: data.crewid },
      query: { sid: ctx.saveId },
    })
  },
}
